import Faq from '@/content/faq';
import {withBgBrownRose50} from '@/hocs/withColors';
import {withMarginBottomXl} from '@/hocs/withSpacing';
import Link from '@/links';
import {SectionPadding} from '@/section';
import {P} from '@/typography';
import {ListTerms} from '@/ui/lists/list-icons';

const SectionFaq = withBgBrownRose50(SectionPadding);
const DivMarginedBottomXl = withMarginBottomXl('div');
const FaqQuestions = [
  {
    question: <>What do I need to do to become a referral partner?</>,
    answer: (
      <P>
        First, let us know you’re interested by filling out our{' '}
        <Link href="/partnership-program/apply" variant="default">
          partner application form
        </Link>
        . Our Partnerships team will review your application and reach out if there’s a fit. Once
        you’ve been approved, we’ll work with you to get the proper referral tracking in place.
      </P>
    )
  },
  {
    question: <>What types of referral partners do you work with?</>,
    answer: (
      <P>
        We work with all kinds! We find that we’re an especially good fit for HR consultants,
        recruiters, professional communities and venture capital firms. Don’t fit into any of those
        categories, but still think you’re a good fit?
      </P>
    )
  },
  {
    question: <>What do I need to do to become a technology partner?</>,
    answer: (
      <P>
        First, let us know you’re interested by filling out our partner application form. Our
        Partnerships team will review your application and reach out if there’s a fit. Once you’ve
        been approved, we’ll set you up with sandbox credentials so you can get started!
      </P>
    )
  },
  {
    question: <>What type of technology partners do you work with?</>,
    answer: (
      <P>
        We work with HR technology partners of all sorts - HRIS, onboarding, payroll, job boards,
        sourcing, referrals, background check providers and many more. Don’t fit into one of those
        categories, but still think you’re a good fit? Then we’d love to hear from you.
      </P>
    )
  },
  {
    question: <>What APIs are available to technology partners?</>,
    answer: (
      <DivMarginedBottomXl>
        <P>We have different APIs available for different solutions:</P>
        <ListTerms>
          <li>
            <Link href="https://workable.readme.io/page/oauth" variant="default">
              OAuth{' '}
            </Link>
            - Sourcing, Payroll, Onboarding, HRIS, Referrals
          </li>
          <li>
            <Link
              href="https://workable.readme.io/page/background-check-providers"
              variant="default">
              Background Check Providers
            </Link>
          </li>
          <li>
            <Link
              href="https://workable.readme.io/page/video-interview-providers"
              variant="default">
              Video Interview Providers
            </Link>
          </li>
          <li>
            <Link href="https://workable.readme.io/page/assessment-providers" variant="default">
              Assessment Providers
            </Link>
          </li>
        </ListTerms>
        <Link href="/developers" variant="cta-default-xs">
          Learn more about Workable’s API
        </Link>
      </DivMarginedBottomXl>
    )
  },
  {
    question: <>What type of support do technology partners get?</>,
    answer: (
      <P>
        Our Partnerships team will provide technical support throughout the integration build
        process (we expect it to take less than 90 days). You’ll also get access to extensive API
        documentation and a sandbox account. Once the integration is ready to test, our engineering
        team will help run QA to ensure success.
      </P>
    )
  },
  {
    question: <>What is the Partner directory?</>,
    answer: (
      <P>
        This is where we feature Integrations and curated partners. Partners get their own page and
        are searchable by our visitors through this website.
      </P>
    )
  }
];

const FaqSection = () => (
  <SectionFaq>
    <Faq
      title="Frequently asked questions"
      questions={FaqQuestions}
      variant="accordion"
      isSafe
      arrow
    />
  </SectionFaq>
);

export default FaqSection;
